import React, { FC } from "react";
import "./desktop_nav.css";
import MenuBar from "shared/MenuBar/MenuBar";
import ModalQuickView from "components/ModalQuickView";
import { Link } from "react-router-dom";
import agro_logo from "./header_logo/agrotrac_log.png";
// import love from './header_logo/love.png'
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import profile_icon from "../../components/userprofile/profile_image/profile_icon.png";
import PageLogin from "containers/PageLogin/PageLogin";
import { useSelector } from "react-redux";
import ProductSearchBar from "./components/ProductSearchBar";
import Navigation from "shared/Navigation/Navigation";
import Logo from "shared/Logo/Logo";
// import GoogleTranslate from "components/googleTranslate/GoogleTranslate";
// import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
//
//
export interface MainNav2LoggedProps {}

const MainNav2Logged: FC<MainNav2LoggedProps> = () => {
  const [showModalQuickView, setShowModalQuickView] = React.useState(false);

  const { isLoggedIn, profile, error } = useSelector(
    (state: any) => state.authSliceReducer
  );
  //
  //

  const ProductSearch = () => {
    return (
      <>
        <div
          className="container-fluid md:container text-xs h-[80px] "
          id="id_input_form"
        >
          <div className="flex items-center justify-center md:justify-between h-full">
            <div className="flex items-center hidden md:block">
              <Link to="/">
                <div className="" style={{ width: "200px" }}>
                  <img src={agro_logo} className="w-full h-full" alt="logo" />
                </div>
              </Link>
            </div>
            <div className="relative w-11/12 my-1 md:hidden">
              {/* For mv */}
              <ProductSearchBar />
            </div>
            {/* search for dv */}
            <header className="max-w-2xl md:max-w-md flex md:w-full hidden md:block">
              <ProductSearchBar />
            </header>

            <div className="hidden md:block">
              <FormControl>
                <NativeSelect
                  defaultValue={30}
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,

                    "&:before": {
                      borderBottom: "1px solid black",
                      width: 60, // focus underline
                    },
                    "&:after": {
                      borderBottom: "1px solid black", // active underline
                    },
                    "& .MuiNativeSelect-icon": {
                      color: "black", // icon color
                    },
                  }}
                >
                  <option value="English">English</option>
                  <option value="Hindi">Hindi</option>
                </NativeSelect>
              </FormControl>
            </div>

            {/* ---------------------------------- */}
            {/* Login/Register Desktop  */}
            {/* ---------------------------------- */}
            <div className="hidden md:block">
              {isLoggedIn ? (
                <div className="flex justify-center items-center rounded-full">
                  {" "}
                  <img
                    src={profile?.data?.profile_img || profile_icon}
                    alt="profile-icon"
                    className="rounded-full"
                    height={35}
                    width={35}
                  />
                  <small className="text-xs cursor-pointer hidden lg:block text-slate-500 block ml-2">
                    <Link to="/profile" className="login_reg_mobile">
                      Hi, <b>{profile?.data?.full_name}</b>
                    </Link>
                  </small>
                </div>
              ) : (
                <div className="flex items-center justify-between">
                  <img
                    src={profile_icon}
                    alt="profile-icon"
                    className="rounded-full mx-2"
                    height={30}
                    width={30}
                  />
                  <Link
                    to="#"
                    onClick={() => setShowModalQuickView(true)}
                    className="login_reg_mobile"
                  >
                    {" "}
                    Login/Register
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderContent = () => {
    return (
      <div className="flex justify-between h-full">
        {/* ---------------------------------- */}
        {/* Login/Register M-View  */}
        {/* ---------------------------------- */}
        <div className="flex items-center lg:hidden  max-w-md">
          <MenuBar />
        </div>

        <Logo className="md:hidden" />

        <div className="flex-[2] hidden lg:flex  items-center  text-md">
          <Navigation />
        </div>

        <div className="md:hidden mt-2">
          {isLoggedIn ? (
            <div className="">
              <Link to="/profile" className="login_reg_mobile">
                <AccountCircleIcon />
              </Link>
            </div>
          ) : (
            <div>
              <Link
                to="#"
                onClick={() => setShowModalQuickView(true)}
                className="login_reg_mobile"
              >
                <AccountCircleIcon />
              </Link>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="nc-MainNav2Logged relative z-10 bg-white dark:bg-neutral-900 dark:border-slate-700">
      <div className="hidden md:block relative">
        <ProductSearch />
      </div>

      <div className="container-fluid bg-[#ffffff] md:bg-[#1550A1]">
        <div className="container h-12">{renderContent()}</div>
      </div>
      <div className="md:hidden">
        <ProductSearch />
      </div>
      <ModalQuickView
        show={showModalQuickView}
        onCloseModalQuickView={() => setShowModalQuickView(false)}
      >
        {!error ? (
          <PageLogin
            onCloseModalQuickView={() => setShowModalQuickView(false)}
          />
        ) : (
          <PageLogin
            onCloseModalQuickView={() => setShowModalQuickView(true)}
          />
        )}
      </ModalQuickView>
    </div>
  );
};

export default MainNav2Logged;
